export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  SUMMARY: '/summary',
  DASHBOARD: '/dashboard'
};
